import { render, staticRenderFns } from "./GoodsPriceEdit.vue?vue&type=template&id=1914521b&"
import script from "./GoodsPriceEdit.vue?vue&type=script&lang=js&"
export * from "./GoodsPriceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports